import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';
import { CustomAttributes } from '@features/client/order-workflow/services/image-capture.service';

@Directive({ standalone: true, selector: '[appHideFromSummaryPdf]' })
export class HideFromSummaryPdfDirective implements OnInit {
  constructor(
    private _elementRef: ElementRef,
    public renderer: Renderer2,
  ) {}

  public ngOnInit(): void {
    this.renderer.setAttribute(this._elementRef.nativeElement, CustomAttributes.html2CanvasIgnoreElement, 'true');
  }
}
